module.exports = __webpack_public_path__ + "img/building95-1.6b848194.jpg";